import translationKeys from '../translationKeys'

export default {
  [translationKeys.CUSTOM_LIST_BTN]: 'Custom list',
  [translationKeys.IN_CUSTOM_LIST]: 'In&nbsp;<strong>Custom list</strong>',
  [translationKeys.ADD_PROSPECT_TO_CUSTOM_LIST]: 'Add prospect to custom list',
  [translationKeys.NAME_YOUR_CUSTOM_LIST]: 'Name your custom list',
  [translationKeys.ADD_YOUR_CUSTOM_LIST]: 'Add new custom list',
  [translationKeys.EDIT_CUSTOM_LISTS]: 'Edit custom lists',
  [translationKeys.EMPTY_CUSTOM_LISTS_TITLE]:
    // eslint-disable-next-line max-len
    'Your custom lists will appear here. Import prospects from partneringONE using the link above or add profiles you find using Search.',
  [translationKeys.EMPTY_ECOMMERCE_CUSTOM_LISTS_TITLE]:
    // eslint-disable-next-line max-len
    'Your custom list will appear here. Import prospects from partneringONE using the link above or add profiles you find using Search.',
  [translationKeys.EMPTY_CUSTOM_LISTS_BTN]: 'Start a list',
  [translationKeys.CUSTOM_LIST_POPUP_CANCEL_BTN]: 'Cancel',
  [translationKeys.CUSTOM_LIST_POPUP_CONFIRM_BTN]: 'Confirm',
  [translationKeys.CUSTOM_LIST_POPUP_ADD_BTN]: 'Add',
  [translationKeys.CUSTOM_LIST_NAME_UNIQUE_ERROR]: 'Name is already in use',
  [translationKeys.MOVE_TO_DIFFERENT_CUSTOM_LIST]: 'Move to different custom list',
  [translationKeys.MOVE_OR_COPY_TO_CUSTOM_LIST]: 'Move or copy',
  [translationKeys.KEEP_PROSPECT_COPY_IN_ORIGNAL_LIST]: 'Keep a copy in current list',
  [translationKeys.DOWNLOAD_CUSTOM_LIST]: 'Download list',
  [translationKeys.DELETE_CUSTOM_LIST]: 'Delete',
  [translationKeys.CUSTOM_LIST_SEARCH_PLACEHOLDER]: 'Search by title',
  [translationKeys.CUSTOM_LIST_SEARCH_LABEL]: 'Search by keyword',
  [translationKeys.SHOW_ON_CUSTOM_LIST_PAGE]: 'Show on custom list page',
  [translationKeys.DELETE_A_CUSTOM_LIST]: 'Delete a custom list',
  [translationKeys.ARE_YOU_SURE_TO_DELETE_A_CUSTOM_LIST]:
    'Are you sure? This action will remove all custom listed items exclusive to this list',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_TITLE]: 'Title',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_EVENT_NAME]: 'Event',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_CONTACT_STATUS]: 'Contact status',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_UPDATED]: 'Profile updated',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_PHASE]: 'Phase',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_NDA]: 'NDA',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_COMPANY_NAME]: 'Company',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_NOTES]: 'Notes',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_PRIORITY]: 'Priority',
  [translationKeys.CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING_SAME]: 'You are both attending this event',
  [translationKeys.CUSTOM_LIST_TABLE_TOOLTIP_BOTH_ATTENDING]: 'You are both attending',
  [translationKeys.CUSTOM_LIST_TABLE_TOOLTIP_NOT_ATTENDING]: 'You are not attending',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_CUSTOM_TAG]: 'Status',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_DATE_ADDED]: 'Date added',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_CONTACT]: 'Actions',
  [translationKeys.CUSTOM_LIST_TABLE_CONTACT_BUTTON]: 'Contact',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_LAST_EVENT]: 'Last event',
  [translationKeys.CUSTOM_LIST_TABLE_HEADER_FUTURE_EVENTS]: 'Future events',
  [translationKeys.CUSTOM_LIST_TABLE_BTN_FUTURE_EVENTS]: 'See more',
  [translationKeys.CUSTOM_LIST_TABLE_CATEGORIES_BUTTON]: 'Category',
  [translationKeys.CUSTOM_LIST_TABLE_ADD_CATEGORY_TITLE]: 'Manage columns',
  [translationKeys.CUSTOM_LIST_ADD_CATEGORY_SUB_TITLE]: 'Show and hide columns',
  [translationKeys.CUSTOM_LIST_TABLE_SORT_CATEGORY]: 'Sort category',
  [translationKeys.CUSTOM_LIST_POPOVER_CANCEL_BTN]: 'Cancel',
  [translationKeys.CUSTOM_LIST_POPOVER_CONFIRM_BTN]: 'Confirm',
  [translationKeys.DELETE_ITEMS]: 'Delete item/s',
  [translationKeys.DO_YO_WANT_PERMANENTLY_DELETE]: 'Do you want to permanently delete this item from your custom list?',
  [translationKeys.NO_ITEM_SELECTED]: 'No item selected',
  [translationKeys.YOU_NEED_TO_SELECT]: 'You need to select one or more items in order to delete them.',
  [translationKeys.YOU_NEED_TO_SELECT_ALERTS_TO_DELETE]: 'You need to select one or more items in order to remove an alert.',
  [translationKeys.YOU_NEED_TO_SELECT_TO_MOVE]: 'You need to select one or more items in order to move them.',
  [translationKeys.YOU_NEED_TO_SELECT_PROFILES_TO_ADD_ALERTS]: 'You need to select one or more profiles to add alerts.',
  [translationKeys.ADD_NOTE_HERE]: 'Add note here',
  [translationKeys.ADD_NOTE]: 'Add note',
  [translationKeys.EDIT_NOTE]: 'Edit note',
  [translationKeys.DELETE_NOTE]: 'Delete note',
  [translationKeys.DUPLICATE_ERROR_TITLE]: 'Duplicate',
  [translationKeys.DUPLICATE_ERROR_TEXT]: 'Sorry this item already appears in this list',
  [translationKeys.ASSET_COMPANY_TITLE]: 'Asset/company title',
  [translationKeys.PROFILE_TITLE_TYPE]: 'Profile type',
  [translationKeys.PROFILE_TITLE_ASC]: 'A to Z',
  [translationKeys.PROFILE_TITLE_DESC]: 'Z to A',
  [translationKeys.ALERT_DATE_ADDED_ASCENDING]: 'Oldest alert added',
  [translationKeys.ALERT_DATE_ADDED_DESCENDING]: 'Most recent alert added',
  [translationKeys.ALERT_DATE_UPDATE_ASCENDING]: 'Oldest update',
  [translationKeys.ALERT_DATE_UPDATE_DESCENDING]: 'Most recent update',
  [translationKeys.ALERT_SORT_BY_PROFILE_TITLE]: 'Sort by title',
  [translationKeys.ALERT_SORT_BY_PROFILE_DATE_ADDED]: 'Sort by date added',
  [translationKeys.ALERT_SORT_BY_PROFILE_DATE_UPDATED]: 'Sort by updated date',
  [translationKeys.ALERT_SORT_BY_FREQUENCY]: 'Sort by frequency',
  [translationKeys.ALERT_FREQUENCY]: 'Frequency',
  [translationKeys.DATE_ADDED_ASCENDING]: 'Date added ascending',
  [translationKeys.DATE_ADDED_DESCENDING]: 'Date added descending',
  [translationKeys.COMPANY_NAME_ASC]: 'Company name ascending',
  [translationKeys.COMPANY_NAME_DESC]: 'Company name descending',
  [translationKeys.NEWEST_EVENT]: 'Newest event',
  [translationKeys.OLDEST_EVENT]: 'Oldest event',
  [translationKeys.MOST_RECENT_EVENT_FIRST]: 'Most recent event first',
  [translationKeys.NEXT_EVENT]: 'Next event',
  [translationKeys.STATUS_TYPE]: 'Status type',
  [translationKeys.DATE_UPDATED_ASCENDING]: 'Date updated ascending',
  [translationKeys.DATE_UPDATED_DESCENDING]: 'Date updated descending',
  [translationKeys.DONE]: 'Done',
  [translationKeys.NOT_DONE]: 'Not done',
  [translationKeys.NEWEST_NOTE]: 'Newest note',
  [translationKeys.OLDEST_NOTE]: 'Oldest note',
  [translationKeys.PRIORITY_HIGH_TO_NOT_SET]: 'From High to Not set',
  [translationKeys.PRIORITY_NOT_SET_TO_HIGH]: 'From Not set to High',
  [translationKeys.STATUS_ASC]: 'Status ascending',
  [translationKeys.STATUS_DESC]: 'Status descending',
  [translationKeys.NEWEST_TEXTS]: 'Newest text',
  [translationKeys.OLDEST_TEXTS]: 'Oldest text',
  [translationKeys.STATUS_DESC]: 'Status descending',
  [translationKeys.STATUS]: 'Status',
  [`${translationKeys.CHARACTERS_LEFT}_other`]: '{{count}} characters left',
  [translationKeys.CHARACTER_LEFT]: '{{count}} character left',
  [translationKeys.MOVE_PROSPECTS]: 'Move prospect(s) to',
  [`${translationKeys.CHARACTERS_LEFT}_one`]: '{{count}} character left',
  [translationKeys.MOVE_PROSPECT_TO_OTHER_CUSTOM_LISTS]: 'Move prospect to other custom list/s',
  [translationKeys.IMPORT_PROSPECTS_FROM]: 'Import prospects from partneringONE',
  [translationKeys.IMPORT_PROSPECTS_TO]: 'Import prospects to partneringONE+',
  [translationKeys.IMPORT_PROSPECTS]: 'Import prospects',
  [translationKeys.ADD_PROSPECTS_TO_CUSTOM_LIST]: 'Add to custom list',
  [translationKeys.MANAGE_AND_TRACK_LIVE_PROSPECTS]: 'Manage and track your live prospects with updates and alerts',
  [translationKeys.PROSPECT_FILTER_INCOMING]: 'Incoming',
  [translationKeys.PROSPECT_FILTER_OUTGOING]: 'Outgoing',
  [translationKeys.PROSPECT_FILTER_REQUESTED]: 'Requested',
  [translationKeys.PROSPECT_FILTER_AGREED]: 'Agreed',
  [translationKeys.PROSPECT_FILTER_DECLINED]: 'Declined',
  [translationKeys.PROSPECT_FILTER_CANCELLED]: 'Cancelled',
  [translationKeys.PROSPECT_FILTER_SECTION_REQUESTS]: 'Requests',
  [translationKeys.PROSPECT_FILTER_SECTION_TAGS]: 'Tags',
  [translationKeys.PROSPECT_FILTER_SECTION_STATUS]: 'Status',
  [translationKeys.UNTAGGED_PROSPECT_FILTER]: 'Untagged',
  [translationKeys.IMPORT]: 'Import',
  [translationKeys.IMPORT_ALL_COUNT_PROSPECT]: 'Import all {{count}} prospects',
  [translationKeys.SELECT_SPECIFIC_PROSPECTS]: 'Select specific prospects',
  [translationKeys.SELECT_ALL_LABEL]: 'Select all',
  [translationKeys.ALL_LABEL]: 'All',
  [translationKeys.SELECT_PARTICIPANT]: 'Choose a participant',
  [`${translationKeys.IMPORT_COUNT_PROSPECT}_one`]: 'Import {{count}} prospect',
  [`${translationKeys.IMPORT_COUNT_PROSPECT}_other`]: 'Import {{count}} prospects',
  [translationKeys.CREATE_A_NEW_CUSTOM_LIST]: 'Create a new custom list',
  [translationKeys.NEW_LIST]: 'New list',
  [translationKeys.ADD_TO_EXISTING_LIST]: 'Add to existing list',
  [translationKeys.HIGH]: 'High',
  [translationKeys.MEDIUM]: 'Medium',
  [translationKeys.LOW]: 'Low',
  [translationKeys.NOT_SET]: 'Not set',
  [translationKeys.CUSTOM_LIST_EDIT_CUSTOM_STATUS]: 'Edit status',
  [translationKeys.CUSTOM_LIST_ADD_NEW_STATUS_BTN]: 'Add new status',
  [translationKeys.CUSTOM_LIST_NO_MORE_STATUSES]: 'New status limit reached',
  [translationKeys.CUSTOM_LIST_CUSTOM_STATUS_NOT_SET]: 'Not set',
  [translationKeys.CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TITLE]: 'Duplicate name',
  [translationKeys.CUSTOM_LIST_DUPLICATE_CUSTOM_STATUS_NAME_ERROR_TEXT]: 'You cannot save duplicate statuses',
  [translationKeys.CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TEXT]: 'You cannot save an empty status name',
  [translationKeys.CUSTOM_LIST_EMPTY_CUSTOM_STATUS_NAME_ERROR_TITLE]: 'Empty name',
  [translationKeys.CUSTOM_LIST_KEEP_EDITING]: 'Keep editing',
  [translationKeys.CUSTOM_LIST_DELETE_CUSTOM_STATUS_TITLE]: 'Delete status',
  [translationKeys.CUSTOM_LIST_DELETE_CUSTOM_STATUS_TEXT]: 'Deleting a status may change the priority of tasks.',
  [translationKeys.MANAGE_COLUMNS]: 'Manage columns',
  [translationKeys.SHOW_AND_HIDE_COLUMNS]: 'Show and hide columns',
  [translationKeys.THIS_MEETING_WAS_IMPORTED]: 'This meeting was imported from an external source',
  [translationKeys.THIS_MEETING_WAS_IMPORTED_FOR_TEAM]:
    'This meeting was imported from an external source and is only visible to your team',
  [`${translationKeys.COUNT_PROSPECTS}_one`]: '{{count}} prospect',
  [`${translationKeys.COUNT_PROSPECTS}_other`]: '{{count}} prospects',
  [`${translationKeys.PROSPECT_MOVED_TO_SHORTLIST}_one`]: "moved to&nbsp;<strong>'{{targetShortlistName}}'</strong>&nbsp;list",
  [`${translationKeys.PROSPECT_MOVED_TO_SHORTLIST}_other`]: 'moved to&nbsp;<strong>{{count}} lists</strong>',
  [`${translationKeys.PROSPECT_COPIED_TO_SHORTLIST}_one`]: "copied to&nbsp;<strong>'{{targetShortlistName}}'</strong>&nbsp;list",
  [`${translationKeys.PROSPECT_COPIED_TO_SHORTLIST}_other`]: 'copied to&nbsp;<strong>{{count}} lists</strong>',
  [translationKeys.ADD_CUSTOM_COLUMN]: 'Add custom column',
  [translationKeys.CUSTOM_COLUMN]: 'Custom column',
  [translationKeys.WITH_A_CUSTOM_COLUMN]:
    'With a custom column you can create assignable categories for any prospect in your custom lists',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_DEFAULT]:
    'With a custom column you can create free text or assignable categories for any prospect in your custom lists',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TEXT_CATEGORY]:
    'Create assignable categories for any prospect in your custom lists',
  [translationKeys.COLUMN_NAME]: 'Column name',
  [translationKeys.DATA_TYPE]: 'Data type',
  [translationKeys.FREE_TEXT]: 'Free text',
  [translationKeys.AUTOCOMPLETE]: 'Dropdown list',
  [translationKeys.ADD_TEXT_HERE]: 'Add text here',
  [translationKeys.ADD_TEXT]: 'Add text',
  [translationKeys.EDIT_TEXT]: 'Edit text',
  [translationKeys.DELETE_TEXT]: 'Delete text',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_BE_EMPTY]: 'Category name is required',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_CATEGORY_NAME_SHOULD_NOT_DUPLICATE]: 'Category name already exists',
  [translationKeys.CUSTOM_LIST_ADD_NEW_CATEGORY]: 'Add new category',
  [translationKeys.CUSTOM_LIST_ADD_CUSTOM_COLUMNS]: 'Add custom column',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY]: 'Delete category',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_DELETE_CATEGORY_TEXT]:
    "Are you sure? All prospects assigned to this category will revert to 'Not Set' for this column.",
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_BE_EMPTY]: 'Column name is required',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_NAME_SHOULD_NOT_DUPLICATE]: 'Column name already exists',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_POPOVER_TITLE]: 'Custom column',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_YOU_HAVENOT_SAVED_CHANGES]: 'All unsaved changes will be lost',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_DATA_TYPE_IS_REQUIRED]: 'Column type is required',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_ADD_FILTER_BTN]: 'Add filter',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_REMOVE_ALL_BTN]: 'Remove all',
  [translationKeys.CONTAINS]: 'Contains',
  [translationKeys.EQUALS]: 'Equals',
  [translationKeys.IS_EMPTY]: 'Is empty',
  [translationKeys.IS_NOT_EMPTY]: 'Is not empty',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST]: 'Filter',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_POPOVER_TEXT]: 'Combine filters to narrow down results',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_OPERATOR]: 'Operator',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_COLUMN]: 'Column',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_VALUE]: 'Value',
  [translationKeys.CUSTOM_LIST_FILTER_LOGIC_COMBINATION]: 'Logic',
  [translationKeys.CUSTOM_LIST_FILTER_SHORTLIST_BTN]: 'Filter',
  [translationKeys.AND]: 'And',
  [translationKeys.OR]: 'Or',
  [translationKeys.CUSTOM_LIST_CUSTOM_COLUMN_COLUMN_NAME_ALREADY_EXISTS]: 'Column name already exists',
  [`${translationKeys.ADD_ALL_PROSPECTS_TO_SHORTLIST_POPOVER_TITLE}_one`]: 'Add {{count}} prospect to custom list',
  [`${translationKeys.ADD_ALL_PROSPECTS_TO_SHORTLIST_POPOVER_TITLE}_other`]: 'Add {{count}} prospects to custom list',
  [translationKeys.ADD_ALL_PROSPECTS_TO_SHORTLIST_SUBTEXT]:
    'Some prospects may already be in your custom lists, duplicates will not be added.',
  [translationKeys.ADD]: 'Add',
  [translationKeys.ADD_ALL_PROSPECTS_TO_SHORTLIST]: 'Save results to custom list',
  [translationKeys.ADD_ALL_PROSPECTS_TO_SHORTLIST_BUTTON_TOOLTIP]:
    /* eslint-disable-next-line max-len */
    'A maximum of 500 prospects can be saved at a time. \n You can refine your search by using filters or a more specific search term.',
  [translationKeys.PROSPECTS_ADDED_TO_SHORTLIST]: 'Any prospects not already in this list have been added',
  [translationKeys.PROSPECTS_ADDED_TO_SHORTLIST_SUBTEXT]:
    'Some prospects may already be in your custom list, duplicates will not be added.',
  [`${translationKeys.CUSTOM_LIST_FILTER_APPLIED}_one`]: '{{count}} filter applied',
  [`${translationKeys.CUSTOM_LIST_FILTER_APPLIED}_other`]: '{{count}} filters applied',
}
